import Sidebar from "./Sidebar";
import './api_dashboard.css';
import './app-wide.css';
import React, { useState } from "react";
import Modal from "./Modal";
import DashBoardAPIItem from "./dashboard_api_item";
import { fetchItems,createItem } from "../api/networking";



const sections = [
  { id: "section-1", title: "Setup", content: "Instructions on how to get started, authenticate your account, and make your first API request.", endpoint: null },

  { id: "section-2", title: "Balance Sheet", content: "Retrieve a company’s balance sheet over a specified time frame, including assets, liabilities, and equity.", endpoint: "get_balance_sheets", column: ["stock_symbol", "authorization"] },

  { id: "section-3", title: "Income Statement", content: "Access the income statement of a company, showing revenue, expenses, and net income for a given period.", endpoint: "get_income_sheets", column: ["stock_symbol", "authorization"] },

  { id: "section-4", title: "CashFlow Statement", content: "Pull a company’s cash flow statement to analyze operating, investing, and financing cash movements.", endpoint: "get_cashflow_sheets", column: ["stock_symbol", "authorization"] },

  { id: "section-5", title: "CPI", content: "Fetch Consumer Price Index (CPI) data, measuring inflation over time.", endpoint: "cpi", column: ["authorization"] },

  { id: "section-6", title: "GDP", content: "Retrieve Gross Domestic Product (GDP) data to track overall economic output.", endpoint: "gdp", column: ["authorization"] },

  { id: "section-7", title: "Real GDP", content: "Get inflation-adjusted GDP figures (Real GDP) for accurate economic growth tracking.", endpoint: "real_gdp", column: ["authorization"] },

  { id: "section-8", title: "Unemployement", content: "Pull unemployment rate data to measure labor market conditions.", endpoint: "unemployment", column: ["authentication"] },

  { id: "section-9", title: "M2 Supply", content: "Access M2 money supply data to analyze liquidity in the economy.", endpoint: "m2_supply", column: ["authorization"] },

  { id: "section-10", title: "Consumer Sentiment", content: "Retrieve University of Michigan Consumer Sentiment Index data to gauge household confidence.", endpoint: "michigan_consumer_sentiment", column: ["authorization"] },

  { id: "section-11", title: "10 Year Treasury", content: "Fetch 10-Year Treasury yield data for long-term interest rate trends.", endpoint: "ten_year_treasury", column: ["authorization"] },

  { id: "section-12", title: "2 Year Treasury", content: "Retrieve 2-Year Treasury yield data for short-term bond market analysis.", endpoint: "two_year_treasury", column: ["authorization"] },

  { id: "section-13", title: "Non-Farm Payroll", content: "Access monthly U.S. employment data excluding farm workers, a key labor market indicator.", endpoint: "non_farm_payroll", column: ["authorization"] },

  { id: "section-14", title: "Capacity Util", content: "Pull Capacity Utilization data to measure industrial sector efficiency and output levels.", endpoint: "cap_util", column: ["authorization"] },

  { id: "section-15", title: "New Private Owned Housing", content: "Retrieve data on new privately owned single-family houses created.", endpoint: "new_single_family_houses_created", column: ["authorization"] },

  { id: "section-16", title: "New Housing Sold", content: "Fetch statistics on sales of new single-family homes.", endpoint: "new_single_family_houses_sold", column: ["authorization"] },

  { id: "section-17", title: "30 Year Mortgage Rate", content: "Retrieve historical 30-Year fixed mortgage rates, a key housing market indicator.", endpoint: "thirty_year_mortgage", column: ["authorization"] },

  { id: "section-18", title: "S&P 500 Index", content: "Access S&P 500 Index values for broad U.S. stock market performance tracking.", endpoint: "s&p_500_index", column: ["authorization"] },

  { id: "section-19", title: "DOW Jones Industrial Average Index", content: "Retrieve Dow Jones Industrial Average data, representing 30 major U.S. companies.", endpoint: "dow_jones_index", column: ["authorization"] },

  { id: "section-20", title: "NASDQ Composite Index", content: "Retrieve NASDQ Composite Index, representing over 3000 common equities listed on the NASDAQ stock Market.", endpoint: "nasdaq_composite_index", column: ["authorization"] },



];

const sectionSideBarNav = [
  {
    id: "section-1", title: "Overview", content:[  { id: "section-1", title: "Setup", content: "Lorem ipsum 1" }]
  },
  {
      id: "section-2", title: "Financial", content: [ 
      { id: "section-2", title: "Balance Sheet", content: "Lorem ipsum 2" },
      { id: "section-3", title: "Income Statement", content: "Lorem ipsum 3" },
      { id: "section-4", title: "CashFlow Statement", content: "Lorem ipsum 4" },
    ]
  },
  {
    id: "section-5", title: "Supplement", content: [  
    { id: "section-5", title: "CPI", content: "Lorem ipsum 4" },
    { id: "section-6", title: "GDP", content: "Lorem ipsum 5" },
    { id: "section-7", title: "Real GDP", content: "Lorem ipsum 6" },
    { id: "section-8", title: "Unemployement", content: "Lorem ipsum 7" },
    { id: "section-9", title: "M2 Supply", content: "Lorem ipsum 8" },
    { id: "section-10", title: "Consumer Sentiment", content: "Lorem ipsum 9" },
    { id: "section-11", title: "10 Year Treasury", content: "Lorem ipsum 10" },
    { id: "section-12", title: "2 Year Treasury", content: "Lorem ipsum 11" },
    { id: "section-13", title: "Non-Farm Payroll", content: "Lorem ipsum 12" },
    { id: "section-14", title: "Capacity Util", content: "Lorem ipsum 13" },
  ]
  },
  {
    id: "section-15", title: "REITS", content: [  
      { id: "section-15", title: "New Private Owned Housing", content: "Lorem ipsum 14" },
      { id: "section-16", title: "New Housing Sold", content: "Lorem ipsum 15" },
      { id: "section-17", title: "30 Year Mortgage Rate", content: "Lorem ipsum 16" },
    ]
  },{
    id: "section-18", title: "Indexs", content: [ 
      { id: "section-18", title: "S&P 500 Index", content: "Lorem ipsum 17" },
      { id: "section-19", title: "DOW Jones Industrial Average Index", content: "Lorem ipsum 18" },
      { id: "section-20", title: "NASDQ Composite Index", content: "Lorem ipsum 19" }]
  }

];


const APIDashboard = ({initials, passedEmail}) => {
  const [showModal, setShowModal] = useState(false);
  const [apiKey, setApiKey] = useState(null);

    const [open, setOpen] = useState(false);

  const toggleMenu = () => setOpen(!open);

  const handleFetchApiKey = async() => {
    console.log("Email: ", passedEmail)
    try{
      const response = await createItem(`/get_api_token?email=${encodeURIComponent(passedEmail)}`);
      if (response[0] == 200){
        setApiKey(response[1]['api_key'])
      }
      
      
    }
    catch(e){
      console.log("Error")
    }

  };
  
  return (
    <div className="dashboard-api">
    <Sidebar sections={sectionSideBarNav} />
    <div className="dashboard-content-api">
        {/* Top Static Header */}
        <div className="dashboard-header">
                <h1 className="dashboard-title">Welcome To The API Dashboard</h1>
                <div className="profile-circle-api drop-shadow" onClick={() => setShowModal(true)}>
                  {initials}
                </div>
          </div>

        <main className="dashboard-main-api">
          {sections.map((section) => (
            <section
              key={section.id}
              id={section.id}
              className="dashboard-section"
            >
              <DashBoardAPIItem section={section}></DashBoardAPIItem>
            </section>
          ))}
        </main>
      </div>
         {/* Modal */}
         {showModal && (
        <Modal onClose={() => setShowModal(false)}>
          <h2>Generate API Key</h2>
          <p>Your API key is:</p>
          {apiKey ? (
            <code className="api-key">{apiKey}</code>
          ) : (
            <button onClick={handleFetchApiKey}>Generate API Key</button>
          )}
        </Modal>
      )}
  </div>
  );
};

export default APIDashboard;